module.exports = __webpack_public_path__ + "img/dialog-bg.3d4b9d60.png";